import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import BtnStatus from '../configuration/status/BtnStatus';
import ModalSgoModifyStart from '../../modals/ModalSgoModifyStart';
import { _$, _setText } from '../../../controllers/dom';
import ModalSgoVehicle from '../../modals/ModalSgoVehicle';

const Response = (props) => {
    const { locale, ModuleRP, mission, buildings, vehicleModels, players } = props;
    const [waitEngage, setWaitEngage] = useState(false);
    const [propose, setPropose] = useState(false);
    const [vehicleModal, setVehicleModal] = useState({});

    const proposeVehicles = () => {
        setPropose(true);
        ModuleRP.proposeVehicles(mission.id);
    };

    const engage = () => {
        setWaitEngage(true);
        ModuleRP.engage(mission.id);
    };

    useEffect(() => {
        if (mission.vehicles.length === 0 && _$('modalRp').style.display !== 'block' && !propose) {
            setPropose(true);
            proposeVehicles();
        }
        if (waitEngage && !mission.vehicles.find((v) => v.status === ModuleRP.listStatus.find((s) => s.system === 'SELECTED').code)) {
            setWaitEngage(false);
            _setText('btn-engage', locales[locale].sgo.engage);
        }
    }, [mission, buildings, vehicleModal]);

    return (
        <>
            <ModalSgoModifyStart
                locale={locale}
                buildings={buildings}
                listStatus={ModuleRP.listStatus}
                mission={mission}
                ModuleRP={ModuleRP}
                vehicleModels={vehicleModels}
            />
            <ModalSgoVehicle
                locale={locale}
                vehicle={vehicleModal}
                listStatus={ModuleRP.listStatus}
                buildings={buildings}
                ModuleRP={ModuleRP}
                players={players}
            />
            <div className='alert alert-secondary'>
                <div className='row'>
                    <div className='col-4'>
                        {
                            mission.vehicles.length === 0 ? (

                                <button type='button' className='btn btn-warning p-0 pl-2 pr-2 m-1' onClick={proposeVehicles}>
                                    {locales[locale].sgo.propose}
                                </button>
                            ) : null
                        }
                    </div>
                    <div className='col-4'>
                        {locales[locale].sgo.search}
                    </div>
                    <div className='col-4'>
                        <button type='button' className='btn btn-info p-0 pl-2 pr-2 m-1' data-toggle='modal' data-target='#modalRp'>
                            {locales[locale].sgo.modify}
                        </button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div>
                            {
                                buildings.map((building, index) => {
                                    if (building.vehicles.find((v) => v.missionId === mission.id)) {
                                        return (
                                            <div key={index} className='row'>
                                                <BtnStatus
                                                    text={building.name}
                                                    listStatus={[]}
                                                />
                                                {
                                                    building.vehicles.map((vehicle, index) => {
                                                        if (vehicle.missionId === mission.id) {
                                                            let outdated = false;
                                                            if (Number(vehicle.status) === Number(ModuleRP.listStatus.find((s) => s.system === 'ALERT').code) && // eslint-disable-line
                                                                vehicle.timestamp + 300000 < Date.now()
                                                            ) {
                                                                outdated = true;
                                                            }
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => {
                                                                        if (vehicle.status !== 50) {
                                                                            setVehicleModal(vehicle);
                                                                        }
                                                                    }}
                                                                    data-toggle={vehicle.status !== 50 ? 'modal' : ''}
                                                                    data-target={vehicle.status !== 50 ? '#modalVehicle' : ''}
                                                                    style={{ cursor: vehicle.status !== 50 ? 'pointer' : 'not-allowed' }}
                                                                >
                                                                    <BtnStatus
                                                                        text={`${vehicle.name}${vehicle.armedFunction ?
                                                                            ` [${vehicle.armedFunction}]` :
                                                                            ''}`
                                                                        }
                                                                        code={vehicle.status}
                                                                        listStatus={ModuleRP.listStatus}
                                                                        outdated={outdated}
                                                                        locale={locale}
                                                                    />
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </div>
                                        );
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 text-right'>
                        {
                            mission.vehicles.find((v) => Number(v.status) === Number(ModuleRP.listStatus.find((s) => s.system === 'SELECTED').code)) ? (
                                <button
                                    type='button'
                                    className='btn btn-success p-1 pl-3 pr-3 m-1'
                                    id='btn-engage'
                                    onClick={engage}
                                    disabled={waitEngage}
                                >
                                    {locales[locale].sgo.engage}
                                </button>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Response;
